import { d as t, C as e, t as i } from "./component-CAYPdBLR.js";
class o extends e {
  requiredRefs = ["button"];
  #e = 300;
  #s = !1;
  connectedCallback() {
    super.connectedCallback();
    const s = i(() => this.#t(), 100);
    (window.addEventListener("scroll", s, { passive: !0, signal: this.signal }), this.#t());
  }
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  #t() {
    const s = window.scrollY > this.#e;
    s && !this.#s ? this.#i() : !s && this.#s && this.#o();
  }
  #i() {
    ((this.#s = !0),
      this.refs.button.classList.add("is-visible"),
      this.refs.button.setAttribute("aria-hidden", "false"));
  }
  #o() {
    ((this.#s = !1),
      this.refs.button.classList.remove("is-visible"),
      this.refs.button.setAttribute("aria-hidden", "true"));
  }
}
t("back-to-top", o);
